import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import Collection from './components/Dispositions';
import Object from './components/Disposition';

import ObjectOnePage from './components/One_Pages';

import CollectionPending from './components/Pendings';
import ObjectPending from './components/Pending';
import ObjectLeep from './components/Leep';

import CollectionEnicsStatus from './components/Enics_Statuses';

import CollectionMultipleSales from './components/Multiple_Sales';

import CollectionCancelled from './components/Cancels';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, locations, states, kiosks, reloadShell, kioskMode, scannedCode, reloadPage, leepUsername, leepPassword, userAccess}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection locations={locations} states={states} kiosks={kiosks} scannedCode={scannedCode} reloadPage={reloadPage}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/one_page`}>
				<ObjectOnePage locations={locations} states={states} kiosks={kiosks} reloadShell={reloadShell} kioskMode={kioskMode}/>
			</ErrorBoundaryRoute>

			{/*<ErrorBoundaryRoute exact path={`${match.url}/one_page/:id/:customer`}>*/}
			{/*	<ObjectOnePage locations={locations} states={states} kiosks={kiosks} reloadShell={reloadShell} kioskMode={kioskMode}/>*/}
			{/*</ErrorBoundaryRoute>*/}

			<ErrorBoundaryRoute exact path={`${match.url}/one_page/:id`}>
				<ObjectOnePage locations={locations} states={states} kiosks={kiosks} reloadShell={reloadShell} kioskMode={kioskMode}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/pendings`}>
				<CollectionPending locations={locations} states={states} kiosks={kiosks} reloadShell={reloadShell}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/pendings/:id/leep`}>
				<ObjectLeep locations={locations} states={states} kiosks={kiosks} scannedCode={scannedCode} reloadShell={reloadShell} leepUsername={leepUsername} leepPassword={leepPassword} baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/pendings/:id`}>
				<ObjectPending locations={locations} states={states} kiosks={kiosks} scannedCode={scannedCode} reloadShell={reloadShell} baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/enics_statuses`}>
				<CollectionEnicsStatus locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/multiple_sales`}>
				<CollectionMultipleSales locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/cancels`}>
				<CollectionCancelled locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object locations={locations} states={states} scannedCode={scannedCode} baseUrl={`${match.url}`} kioskMode={kioskMode} userAccess={userAccess}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
